export default {
      id: "ic-misc-folder-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-folder-usage",
      toString: function () {
        return this.url;
      }
    }